import { Profile } from "common/types"
import { get, put } from "hooks/use-http/useHttp"


export const fetchProfile = async (userId: string) => {
    const response: Profile = await get(`profile/${userId}`)
    return response
}

export const fetchProfileWithApiKey = async (id: string) => {
    const response: Profile = await get(`profile/${id}`, { useApiKey: true })
    return response
}

export const updateProfile = async (profile: Profile) => {
    const response: Profile = await put(`profile/${profile.userId}`, profile)
    return response
}

export const useUserProfileApi = () => {
    return {
        fetchProfile,
        fetchProfileWithApiKey,
        updateProfile
    } as const
}